import { ContentfulFAQ } from 'api/contentful/getContentfulFAQ'
import { FaqTwoColumns } from 'components/faqTwoColumn/FaqTwoColumn'
import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Layout } from 'components/layout/Layout'
import { PageMeta } from 'components/PageMeta'
import { PageTitle } from 'components/PageTitle'
import { DirectivePricingCard } from 'components/pricingPage/card/DirectivePricingCard'
import { StartSection } from 'components/pricingPage/section/StartSection'
import { PricingPlanFeatures } from 'components/pricingPlanFeatures/PricingPlanFeatures'
import { Spacer } from 'components/spacer/Spacer'
import { Stack } from 'components/Stack'
import { startDirectiveFlow } from 'logic/directive/create/start'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'
import { EstatePlanningPriceType } from 'utils/getInitialEstatePlanningPrice'

export function PricingPage(props: {
  faq: ContentfulFAQ
  estatePlanningPrice: EstatePlanningPriceType
}) {
  const { isLogged } = useAuth()
  const { t } = useTranslation('pricing_plan')
  return (
    <Layout header={<TopNavigationLandingPage variant="estate-planning" />}>
      <PageTitle title={t('pricing_plan.pricing_page.meta_title')} />
      <PageMeta description={t('pricing_plan.pricing_page.meta_description')} />
      <Stack space="1.5rem">
        <StartSection estatePlanningPrice={props.estatePlanningPrice} />
        <Stack
          orientation={['vertical', 'horizontal']}
          css={{ justifyContent: 'center', margin: '0 1rem', alignItems: 'center' }}
          space={['1.5rem', '2rem']}
        >
          <DirectivePricingCard
            directive="WILL"
            sendAnalyticsStartEvent={() =>
              startDirectiveFlow('WILL', {
                simpleFlowPlace: 'pricing',
                routerMechanism: 'push',
                isLogged: !!isLogged,
                fromInside: true,
              })
            }
          />
          <DirectivePricingCard
            directive="TRUST"
            color={colors.trust.primary}
            sendAnalyticsStartEvent={() =>
              startDirectiveFlow('TRUST', {
                simpleFlowPlace: 'pricing',
                routerMechanism: 'push',
                isLogged: !!isLogged,
                fromInside: true,
              })
            }
          />
        </Stack>
      </Stack>
      <Spacer size="3rem" />
      <PricingPlanFeatures />
      <Spacer size="4.5rem" />
      <FaqTwoColumns content={props.faq} />
      <Spacer size={['4.5rem', 0]} />
    </Layout>
  )
}
